import { PrintCardMenu } from './print-card-menu';
import { Position } from '../../enum/shared/position.enum';
import { FONT } from '../font-style-sheets';

export class PlainJanePrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent() {
    return [
      FONT.Poppins.Medium_500,
      FONT.Poppins.SemiBold_600,
      FONT.Poppins.Bold_700,
      FONT.Poppins.ExtraBold_800,
      FONT.RealistNarrow.Regular_400,
      FONT.RealistNarrow.Bold_700,
      FONT.RealistNarrow.ExtraBold_800,
      FONT.RealistWide.Regular_400,
      FONT.RealistWide.Bold_700,
      FONT.RealistWide.ExtraBold_800
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/afb8gdm.css';
  }

  shouldStandardizeDominantStrainType() {
    return false;
  }

  primaryPriceColumnAlsoShowOriginalPriceIfOnSalePosition(): Position {
    return Position.Top;
  }
}
